import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NotificacionService } from './notificacion.service';
import { NotificacionEntry } from 'src/app/shared/entrys/notificacion.entry';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SolicitudesService } from '../../funcionario/solicitudes/solicitudes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalCorreoMensajeComponent } from 'src/app/components/core/layouts/modal-correo-mensaje/modal-correo-mensaje.component';
import { AyudasService } from 'src/app/components/contenido/containers/ayudas/ayudas.service';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';

@Component({
	selector: 'app-notificacion',
	templateUrl: './notificacion.component.html',
	styleUrls: ['./notificacion.component.scss']
})
export class NotificacionComponent implements OnInit {
	headers: Array<string>;
	dataTabla: DatoPaginadoModel;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	rnt: RNTPrestadorEntry;
	suscripcion: Subscription;
	notificiones: Array<NotificacionEntry>;
	formFiltroNotificacion: FormGroup;
	tipos_solicitud: Array<any>;
	establecimiento: any;
	paginaActual: number;
	constructor(private dataSharedService: DataSharedService, private notificacionService: NotificacionService,
		formBuilder: FormBuilder, private solicitudesService: SolicitudesService, private modalService: NgbModal,
		public ayudaService: AyudasService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.establecimiento = {};
		this.formFiltroNotificacion = formBuilder.group({
			numero_radicacion: [''],
			tipo_solicitud_id: [''],
			// tipo_notificacion: [''],
			// asunto: [''],
			fecha_envio: [''],
			// estado: ['']
		});
		this.suscripcion = dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.getNotificaciones({ ...this.rnt, ...this.formFiltroNotificacion.value }, 1);
		this.headers = ['Fecha de Envío', 'Número Radicado', 'Tipo Solicitud', 'Asunto Enviado', 'Tipo Notificación','Causal de devolución', 'Acción'];
		this.notificacionService.getDetalleEstablecimientoPublico(this.rnt).subscribe(resultado => {
			if (resultado.result) {
				this.establecimiento = resultado.data;
			}
		});
		this.onSolicitudes();
	}

	onFiltrar() {
		this.paginaActual = 1;
		this.getNotificaciones({ ...this.rnt, ...this.formFiltroNotificacion.value }, 1);
	}

	reset() {
		this.formFiltroNotificacion.reset();
		this.onFiltrar();
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.getNotificaciones({...this.rnt, ...this.formFiltroNotificacion.value,numero_radicacion:this.formFiltroNotificacion.value.numero_radicacion}, value);
	}
	onSolicitudes() {
		this.solicitudesService.getTiposSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.tipos_solicitud = resultado.data;
			}
		});
	}

	onCorreoMensaje(entry: NotificacionEntry) {
		const modalRef = this.modalService.open(ModalCorreoMensajeComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
		modalRef.componentInstance.notificacion = entry;
	}

	get TipoRnt() {
		return TipoRnt;
	}

	getNotificaciones(filtro, page) {
		this.notificacionService.get({ ...filtro, numeroPagina: page }).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.notificiones = this.dataTabla.items as Array<NotificacionEntry>;
			}
		});
	}
}
